var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('memlist-modal',{ref:"popup"},[_c('div',{staticClass:"native-progress-wrapper"},[_c('div',{staticClass:"native-progress-bar",style:({ width: _vm.progressPercent + '%' })},[_c('span',{staticClass:"progress-label"},[_vm._v(" Progress: "),_c('strong',[_vm._v(_vm._s(_vm.current_value.toFixed(2))+" / "+_vm._s(_vm.max_value))])])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }